import React from "react";
import "./CircleCharts.css";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const CircleCharts = () => {
  return (
    <>
      <div id="circle-charts-main">
        <div className="circle-charts-container">
          <CircularProgressbar
            styles={buildStyles({
              pathColor: "#30A2FF",
              textColor : "#30A2FF"
            })}
            strokeWidth={18}
            value={75}
            text={"46%"}
          />
          <p>
            46% of people will meet the criteria for a diagnosable mental health
            condition sometime in their life.
          </p>
        </div>
        <div className="circle-charts-container">
          <CircularProgressbar
            styles={buildStyles({
              pathColor: "#30A2FF",
              textColor : "#30A2FF"
            })}
            strokeWidth={18}
            value={75}
            text={"20%"}
          />
          <p>20% of US adults suffer with mental illness.</p>
        </div>
        <div className="circle-charts-container">
          <CircularProgressbar
            styles={buildStyles({
              pathColor: "#30A2FF",
              textColor : "#30A2FF"
            })}
            strokeWidth={18}
            value={75}
            text={"16%"}
          />
          <p>16% of US youth aged 6-17 experience a mental health disorder each year</p>
        </div>
        <div className="circle-charts-container">
          <CircularProgressbar
            styles={buildStyles({
              pathColor: "#30A2FF",
              textColor : "#30A2FF"
            })}
            strokeWidth={18}
            value={75}
            text={"18%"}
          />
          <p>18% of the US population suffer from anxiety disorders each year</p>
        </div>
      </div>
    </>
  );
};

export default CircleCharts;
